// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".owndialog[data-v-3bd12af7] {\n  z-index: 9999;\n}\n", ""]);
// Exports
module.exports = exports;
